import { useStoreState } from 'easy-peasy'
import React from 'react'
import type { StoreModel } from 'src/store/types'
import { AudioLevelV2 } from './audio-level-v2'

export const AudioLevelClient = () => {
  const { tabAudioLevel } = useStoreState((state: StoreModel) => state.volume)

  return <AudioLevelV2 label="Client's microphone" audioLevel={tabAudioLevel} />
}
